import { Config } from '@adornis/config/config.js';

export const SAML_IMPLEMENTATIONS = ['tu-darmstadt', 'adornis-authentik', 'hs-fulda', 'dfn-aai'] as const;

export const config = new Config('buchungsheld', {
  // if empty will not render saml login functionality
  SAML_IMPLEMENTATION: {
    env: true,
    name: 'SAML_IMPLEMENTATION',
    client: true,
    required: false,
    defaultVal: '',
    parse(value) {
      if (value && !SAML_IMPLEMENTATIONS.includes(value as any))
        throw new Error(
          `SAML_IMPLEMENTATION has to be one of the following: ${SAML_IMPLEMENTATIONS.join(', ')}. Got ${value}`,
        );
      return value as (typeof SAML_IMPLEMENTATIONS)[number] | '';
    },
  },
  // if true will use popup for saml login
  SAML_USE_POPUP: {
    env: true,
    name: 'SAML_USE_POPUP',
    client: true,
    required: false,
    defaultVal: '',
  },
  //reads the preselected IdP
  SAML_PRESELECTED_IDP: {
    env: true,
    name: 'SAML_PRESELECTED_IDP',
    client: true,
    required: false,
    defaultVal: '',
  },

  // features
  USE_NEWSLETTER_FEATURE: {
    env: true,
    required: false,
    client: true,
    name: 'USE_NEWSLETTER_FEATURE',
    parse: (val: string | boolean) => {
      return val === 'true' || val === true;
    },
    defaultVal: 'false',
  },

  USE_DATE_IN_PODUCT_CARD_SOON_AVAILABLE_BANNER: {
    env: true,
    required: false,
    client: true,
    name: 'USE_DATE_IN_PODUCT_CARD_SOON_AVAILABLE_BANNER',
    parse: (val: string | boolean) => {
      return val === 'true' || val === true;
    },
    defaultVal: 'false',
  },

  USE_PRODUCT_ANBIETER: {
    env: true,
    required: false,
    client: true,
    name: 'USE_PRODUCT_ANBIETER',
    parse: (val: string | boolean) => {
      return val === 'true' || val === true;
    },
    defaultVal: 'false',
  },

  USE_ICSRM_MATCHINGWEEK_BANNER: {
    env: true,
    required: false,
    client: true,
    name: 'USE_ICSRM_MATCHINGWEEK_BANNER',
    parse: (val: string | boolean) => {
      return val === 'true' || val === true;
    },
    defaultVal: 'false',
  },
});
